<template>
  <div>
    <div class="form-navbar" style ="margin: auto; width: 100%;">
      <div class="nav-links">
        <a class="btn btn-link end" @click="previousSection">
          <font-awesome-icon icon="chevron-left" />
        </a>
        <router-link class="equipment-detail-links"
          v-for="(route, index) in routes"
          :to="{name: route, query: $route.query, params: { siteNumber: $parent.$attrs.siteNumber }}"
          v-bind:key="route"
          v-bind:class="{visited: index < currentRoute}">
            {{routeTags[index]}}
        </router-link>
        <a class="btn btn-link end" @click="nextSection">
          <font-awesome-icon icon="chevron-right" />
        </a>
      </div>
    </div>
    <div class="form-wrapper eDetails" style="border-top: none; width: 100%">
      <router-view :form="form"
                         :val="$v"
                         class="h-100 d-flex align-content-between flex-wrap"
                         v-bind:fetchingData.sync="fetchingData"
                         v-bind:title.sync="title">
      </router-view>
    </div>
  </div>
</template>

<script>
import { AirAddEquipmentForm } from '~/js/FormObjects';
import { getApplication, getPrices, capitalize, errorNotification } from '~/js/FormFunctions';
import { CapitalizeFilter } from '@/js/Mixins';

export default {
  name: 'Application',
  data() {
    return {
      title: null,
      currentRoute: null,
      form: this.$parent.form,
      routes: [
        'AddEquipmentDetails',
        'EquipmentFileUpload',
        'AddEquipmentReviewChanges',
      ],
      routeTags: [
        '1 Add Equipment Details',
        '2 File Upload',
        '3 Checkout',
      ],
      permitPrices: [],
      fetchingData: false,
    };
  },
  mounted() {
    this.form = this.$parent.form;
    this.currentRoute = 0;
    this.$router.push({ name: this.routes[this.currentRoute], query: this.$route.query });
    // this.currentRoute = 0
  },
  validations: {
  },
  methods: {
    previousSection() {
      if (this.currentRoute > 0) {
        this.$router.push({ name: this.routes[this.currentRoute - 1], query: this.$route.query });
      }
    },
    nextSection() {
      if (this.currentRoute < this.routes.length) {
        this.$router.push({ name: this.routes[this.currentRoute + 1], query: this.$route.query });
      }
    },
    submitForm() {
      if (this.$v.$invalid) {
        this.$v.$touch();
        this.$notify('Errors during permit application validation.', 'error');
        return;
      }

      const vm = this;
      this.mySaveApplication()
        .then((response) => {
          vm.form.id = response.data;

          Object.keys(this.form.files).forEach((key) => {
            if (vm.form.files[key]) {
              vm.form.existingFileDetails[key] = {
                documentName: key,
                name: vm.form.files[key].name,
              };
            }
          });
          vm.$store.commit('application', vm.form);
          vm.$router.push({ name: 'PermitApplicationReview', params: { projectType: vm.projectType } });
        })
        .catch(() => {});
    },
    saveApplication() {
      const self = this;
      this.mySaveApplication()
        .then((response) => {
          self.$router.push({
            name: 'PermitApplicationSaved',
            params: {
              projectType: self.projectType.toLowerCase(),
            },
            query: {
              applicationId: response.data,
            },
          });
        })
        .catch(() => {});
    },
    mySaveApplication() {
      // update the stored list of contractors if the name changed
      if (this.form.projectType.toLowerCase() === 'demolition') {
        if (this.form.contractor && this.form.contractor.id) {
          const contractors = this.$store.getters.contractors(this.form.projectType.toLowerCase());
          const contractor = contractors.find(c => c.id === this.form.contractor.id);
          if (contractor && contractor.name !== this.form.contractor.name) {
            contractor.name = this.form.contractor.name;
          }
        } else if (this.form.contractor.name) {
          /**
           * we can't add the contractor to the list if its a new contractor since we won't know the id. we'll just delete
           * the list and re-fetch it again.
           */
          this.$store.commit('demolitionContractors', []);
        }
      }

      const self = this;

      const formData = new FormData();
      Object.keys(this.form.files).forEach((key) => {
        if (self.form.files[key]) {
          formData.append(key, self.form.files[key]);
        }
      });

      formData.append('form', JSON.stringify(this.form));
      this.fetchingData = true;
      return new Promise((resolve, reject) => {
        self.$http.post('/api/permit/save', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
          .then((response) => {
            // console.log(response)
            self.fetchingData = false;
            resolve(response);
          })
          .catch((error) => {
            self.fetchingData = false;
            errorNotification('Error saving application record: ', error);
            reject(error);
          });
      });
    },
    cancel() {
      this.$router.push({ name: 'PermitApplicationCancel', params: { projectType: this.projectType } });
    },
  },
  watch: {
    $route(to) {
      if (this.$route.name != 'AddEquipment') {
        this.currentRoute = this.routes.findIndex(route => to.name.endsWith(route));
      } else {
        this.$router.push({ name: 'AddEquipmentDetails', query: this.$route.query });
      }
    },
  },
};

</script>
